// FP-7707: mutated in place by setV2ExperienceFlag once the real toggle resolves.
export const V2_EXPERIENCE_FLAG = {
  isV2ExperienceEnabled: false,
};

// `let` so this is a live ESM binding — importers see reassignments below.
export let V2_EVENT_PROPERTY = JSON.stringify(V2_EXPERIENCE_FLAG);

// Call once the real BLUE_GREEN_TEST_MERCHANT value is known (see MerchantProvider).
// BLUE_GREEN_TEST_MERCHANT arrives from an async call, so requests fired before it
// resolves would read false. The last resolved value is kept for those.
const V2_FLAG_STORAGE_KEY = 'isV2ExperienceEnabled';

export const isV2Experience = () => {
  if (V2_EXPERIENCE_FLAG.isV2ExperienceEnabled) return true;
  try {
    return localStorage.getItem(V2_FLAG_STORAGE_KEY) === 'true';
  } catch (e) {
    return false;
  }
};

export const setV2ExperienceFlag = (isEnabled) => {
  V2_EXPERIENCE_FLAG.isV2ExperienceEnabled = Boolean(isEnabled);
  try {
    localStorage.setItem(V2_FLAG_STORAGE_KEY, String(Boolean(isEnabled)));
  } catch (e) {
    // storage blocked (private mode) — in-memory flag still works
  }
  V2_EVENT_PROPERTY = JSON.stringify(V2_EXPERIENCE_FLAG);
};
